import React from 'react';
import Box from '@mui/material/Box';
import { DrawerStyled, PanelHeader, PanelSection, PanelTitle, PanelWrapper } from './styles/PanelStyled';
import { CloseIcon } from '../../@theme/assets/svg/actions';
var Panel = function Panel(_ref) {
  var _ref$allowClosePanel = _ref.allowClosePanel,
    allowClosePanel = _ref$allowClosePanel === void 0 ? true : _ref$allowClosePanel,
    children = _ref.children,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '360px' : _ref$maxWidth,
    onClose = _ref.onClose,
    open = _ref.open,
    title = _ref.title,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? '16px' : _ref$padding;
  var sx = {
    width: '100vw',
    '@media screen and (min-width: 768px)': {
      width: maxWidth
    }
  };
  var checkIfClosePanel = function checkIfClosePanel() {
    return allowClosePanel && onClose();
  };
  return React.createElement(DrawerStyled, {
    anchor: "right",
    open: open,
    onClose: checkIfClosePanel
  }, React.createElement(Box, {
    sx: sx,
    role: "presentation"
  }, React.createElement(PanelWrapper, null, React.createElement(PanelHeader, {
    allowClosePanel: allowClosePanel
  }, React.createElement(PanelTitle, null, title), React.createElement(CloseIcon, {
    "data-testid": "panel-close-icon",
    onClick: checkIfClosePanel
  })), React.createElement(PanelSection, {
    panelPadding: padding
  }, children))));
};
export default Panel;